import React, { Component} from 'react';

class RenderImageItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            spans : 0
        };

        this.imageRef = React.createRef();
    }

    componentDidMount() {
        this.imageRef.current.addEventListener('load', this.setSpans);
    }

    setSpans = () => {
        if(this.imageRef.current && this.imageRef.current.clientHeight){
            const height = this.imageRef.current.clientHeight;
            const autoRowsValue = 5;//is taken from grid-auto-rows value inside .css
            const spans = Math.ceil(height / autoRowsValue + 1);
            this.setState({spans : spans});
        }
    };

    render() {
        return (
            <div className='imgContainer' style={{gridRowEnd: `span ${this.state.spans}`}}>
                <img
                    ref={this.imageRef}
                    src={this.props.image.path}
                    className="img-thumbnail"
                    alt="/#"
                    onClick={this.props.onClick}
                />
            </div>
        );
    }
}
export default RenderImageItem;